module.exports = __webpack_public_path__ + "static/fonts/FANGZHENGSHUSONGFANTI-1_0.f90c2a0.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/suft/FANGZHENGSHUSONGFANTI-1_0.ttf
// module id = ByjC
// module chunks = 2